import { Outlet, Navigate, useLocation } from 'react-router-dom';

import { AccessProvider } from '../access';
import { OnboardingGate } from '../modules/onboarding';
import { useSignedOutOnRestore } from '../utilities/customHooks/useSignedOutOnRestore';

export default function AuthenticatedRoute() {
    useSignedOutOnRestore();
    const isLoggedIn = localStorage.getItem('userId');
    const location = useLocation();
    if (!isLoggedIn) {
        return (
            <Navigate
                to="/Login"
                replace
                state={{
                    from: location.pathname + location.search,
                }}
            />
        );
    }
    return (
        <AccessProvider>
            <OnboardingGate>
                <Outlet />
            </OnboardingGate>
        </AccessProvider>
    );
}
